import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from 'store/app/entities/baseQuery';

const initialState = {
  providers: [],
  companyProvider: null,
};

const endpoints = build => ({
  // Get available eSignature providers
  getProviders: build.query({
    query: () => 'v1/esignature/providers',
    transformResponse: response => response.data.providers,
    providesTags: [{ type: 'ESignatureProviders', id: 'LIST' }],
  }),

  // Test eSignature provider configuration
  testProviderConfig: build.mutation({
    query: body => ({
      url: 'v1/esignature/provider/test',
      method: 'POST',
      body,
    }),
    transformResponse: response => response.data,
    // No invalidation needed for test endpoint
  }),

  // Get templates from company's configured eSignature provider
  getTemplates: build.query({
    query: ({ page, limit, offset } = {}) => {
      const params = new URLSearchParams();
      if (page) params.append('page', page);
      if (limit) params.append('limit', limit);
      if (offset) params.append('offset', offset);
      const query = params.toString() ? `?${params.toString()}` : '';
      return `v1/esignature/templates${query}`;
    },
    transformResponse: response => {
      // Handle different response formats from different providers
      // Standard API response format: { status, data: { results: [] } }
      if (response.data?.results) {
        return response.data.results;
      }
      // Direct results array (some providers)
      if (Array.isArray(response.results)) {
        return response.results;
      }
      // Direct data array (some providers)
      if (Array.isArray(response.data)) {
        return response.data;
      }
      // Direct array response
      if (Array.isArray(response)) {
        return response;
      }
      return [];
    },
    providesTags: [{ type: 'ESignatureProviders', id: 'TEMPLATES' }],
  }),
});

const ESignatureProviderSlice = createApi({
  reducerPath: 'eSignatureProviderReducer',
  baseQuery,
  tagTypes: ['ESignatureProviders', 'Companies'],
  initialState,
  keepUnusedDataFor: 30,
  endpoints,
});

export const {
  useGetProvidersQuery,
  useGetCompanyProviderQuery,
  useUpdateCompanyProviderMutation,
  useTestProviderConfigMutation,
  useGetProviderConfigRequirementsQuery,
  useGetTemplatesQuery,
  util: { invalidateTags: invalidateESignatureProviderTags },
} = ESignatureProviderSlice;

export const { reducer: eSignatureProviderReducer, middleware: eSignatureProviderMiddleware } =
  ESignatureProviderSlice;
